import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../../../../../../hooks/useLanguage';
import useMyAppStore from '../../../../../../../stores/myAppStore';

const StatusBar = () => {
  const { lang } = useLanguage();
  const navigate = useNavigate();
  const { currentActivity, pageTitle, selectedLayout, setSelectedLayout } = useMyAppStore();

  // Fonction sécurisée pour formater l'activité
  const formatActivity = (activity) => {
    if (!activity) return 'Activité';
    if (typeof activity === 'string') {
      return activity.charAt(0).toUpperCase() + activity.slice(1);
    }
    if (typeof activity === 'object' && activity.name) {
      return activity.name.charAt(0).toUpperCase() + activity.name.slice(1);
    }
    return 'Activité';
  };

  // Fonction pour changer le layout
  const handleLayoutChange = (layout) => {
    setSelectedLayout(layout);
  };

  // Fonction pour retourner à QuickAccess
  const handleBackToQuickAccess = () => {
    navigate(`/${lang}/myapp/quick-access`);
  };

  return (
    <div className="bg-white border-b border-gray-200 px-4 py-2 flex items-center justify-between">
      {/* Informations de l'activité */}
      <div className="flex items-center gap-4">
        <button
          onClick={handleBackToQuickAccess}
          className="p-2 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-colors"
          title="Retour à l'accès rapide"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
        </button>
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 bg-green-500 rounded-full"></div>
          <span className="text-sm font-medium text-gray-700">
            {formatActivity(currentActivity)}
          </span>
        </div>
        <span className="text-sm text-gray-500">|</span>
        <span className="text-sm text-gray-600">{pageTitle}</span>
      </div>

      {/* Sélecteur de layout pour développement */}
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-2">
          <span className="text-xs text-gray-500">Layout:</span>
          <select
            value={selectedLayout}
            onChange={(e) => handleLayoutChange(e.target.value)}
            className="text-xs border border-gray-300 rounded px-2 py-1 bg-white focus:outline-none focus:ring-1 focus:ring-blue-500"
          >
            <option value="retail">🛒 Retail</option>
            <option value="restaurant">🍽️ Restaurant</option>
            <option value="services">💇‍♀️ Services</option>
            <option value="workshop">🔧 Workshop</option>
          </select>
        </div>
        
        <span className="text-sm text-gray-500">|</span>

        {/* Informations système */}
        <div className="flex items-center gap-4 text-sm text-gray-500">
          <div className="flex items-center gap-1">
            <div className="w-2 h-2 bg-green-500 rounded-full"></div>
            <span>En ligne</span>
          </div>
          <span>|</span>
          <span>{new Date().toLocaleTimeString(lang === 'ar' ? 'ar-MA' : 'fr-FR', { 
            hour: '2-digit', 
            minute: '2-digit' 
          })}</span>
        </div>
      </div>
    </div>
  );
};

export default StatusBar; 